import { render, staticRenderFns } from "./DriverMileage.vue?vue&type=template&id=787156f2&"
import script from "./DriverMileage.vue?vue&type=script&lang=js&"
export * from "./DriverMileage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports